<template>
  <div v-if="showModal" class="modal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <pre>{{ formattedJson }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogModal",
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    jsonResponse: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    formattedJson() {
      if (typeof this.jsonResponse === "string") {
        const data = JSON.parse(this.jsonResponse);
        return JSON.stringify(data, null, 2);
      }

      return this.jsonResponse;
    }
  },
  methods: {
    closeModal() {
      this.$emit("update:showModal", false);
    }
  },

  mounted() {
    window.addEventListener("keyup", this.handleKeyUp);
  },

  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyUp);
  },

  methods: {
    handleKeyUp(e) {
      if (e.key === "Escape") {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("update:showModal", false);
    }
  }
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  padding-right: 50px;
  border: 1px solid #888;
  width: 80%;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.close {
  color: #aaaaaa;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
}
</style>
